import configDefault from "./config-default";

const config = {
  ...configDefault,
  code: "onair.integ",
  companyName: "ON AIR INTEGRATION",
  website: 'https://www.onair-fitness.com/',
  htmlCustomCSS: "ofc.scss",
  notifyChannel: 'onair-fitness',
  onlyOneClub: false,

  payByCard: "STRIPE",

  header: {
    title: "Je m'abonne",
    logo: "/ofc-logo--colored-white.svg",
  },
  footer: {
    ...configDefault.footer,
    logo: "/ofc-logo--white.svg",
  },
  navigation: {
    ...configDefault.navigation,
    display: "line",
  },

  steps: {
    ...configDefault.steps,
    useSinglePageForm: true,

		userForm: {
      ...configDefault.steps.userForm,
			optins: {
				acceptLegal: {
					...configDefault.steps.userForm.optins.acceptLegal,
					text: "J’ai lu et j'accepte les conditions générales de ce club",
					href: 'http://www.perdu.com',
					required: true,
				},
				acceptNewsletter: {
					...configDefault.steps.userForm.optins.acceptNewsletter,
					text: "Je souhaite recevoir les actualités",
				},
				acceptAdvertising: {
					...configDefault.steps.userForm.optins.acceptAdvertising,
					text: "J'accepte de recevoir les offres commerciales",
				},
				acceptPartner: {
					...configDefault.steps.userForm.optins.acceptPartner,
					text: "J'autorise à transmettre mes coordonnées à ses partenaires",
				},
			}
		},

  },
  plans: {
    ...configDefault.plans,
    beforeUser: false,
  },
  clubTransfer: {
    ...configDefault.clubTransfer,
    enabled: true,
  },

  promoCode: {
    label: "Avez-vous un code promo ?",
    placeholder: "VOTRE CODE ICI",
    confirmLabel: "Appliquer",
    verifyingLabel: "En cours de vérification"
  },

};

export default config;
